// extracted by mini-css-extract-plugin
export default {"NotificationsListItem":"NotificationsListItem_NotificationsListItem__-0E1r","Title":"NotificationsListItem_Title__dyFRU","New":"NotificationsListItem_New__nbkg2"};